import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import classnames from "classnames";
import { Play } from "components/icons/Play";

import Styles from "components/menu/SpotifyButton.module.scss";

class SpotifyButton extends Component {

    render () {
        return (
            <a href={"https://open.spotify.com/playlist/4mUHWnFDqlNppiTdUtNON5?si=51csdyfYToyghevWqjUX1w"} className={classnames(Styles["spotifyButton"])} target={"_blank"}>                
              <img src={"https://i.scdn.co/image/ab67706c0000da8416fde07db332d77d63857816"} alt={""} />
              <span>
                <strong>Playlist Glambox Cuidados</strong>
                <small>#GlamboxCuidados</small>
              </span>
              <Play fill={"#B3B3B3"} size={"100%"}/>
            </a>
        )
    }
}

export {
  SpotifyButton
};